import { TABLE_LOADER_INIT_ABORTED } from './useTableLoader.constants'

export function isTableLoaderInitAborted(initResult) {
  return initResult === TABLE_LOADER_INIT_ABORTED
}

export function getTableLoaderListApiParams(params) {
  return params
}
